<template>
  <NuxtLink
    v-track-click="{ cta_name: 'join_movement', cta_location: props.location }"
    :to="to"
  >
    <slot>Take the pledge</slot>
  </NuxtLink>
</template>

<script setup lang="ts">
interface PledgeLinkProps {
  /** Where on the site the link sits, reported as `cta_location`. */
  location: string
}

const props = defineProps<PledgeLinkProps>()

const uiStore = useUIStore()
const route = useRoute()

const school = computed(() => {
  if (uiStore.mountedSchool) {
    return uiStore.mountedSchool
  }

  const querySchool = uiStore.querySchool

  if (!querySchool) {
    return null
  }

  // The store holds on to the last school visited, so only treat it as context
  // when this page is actually about that school.
  const inContext =
    route.params.schoolSlug === querySchool.slug ||
    route.query.school === querySchool.slug

  return inContext ? querySchool : null
})

const to = computed(() =>
  school.value ? `/commitment?school=${school.value.slug}` : '/commitment',
)
</script>
